import { render, staticRenderFns } from "./dataFilter.vue?vue&type=template&id=64479c47&scoped=true&"
import script from "./dataFilter.vue?vue&type=script&lang=js&"
export * from "./dataFilter.vue?vue&type=script&lang=js&"
import style0 from "./dataFilter.vue?vue&type=style&index=0&id=64479c47&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64479c47",
  null
  
)

export default component.exports